<template>
  <div class="wrap">
    <h1>{{ t }}</h1>
    <div class="wrap2">
        <div class="item" v-for="(item,i) in list" :key="item.p1">
            <img :src="require('@/assets/images/simustock/i'+(i+1)+'.png')" />
            <p>{{ item.p1 }}</p><p>{{ item.p2 }}</p>
        </div>
    </div>

  </div>
</template>

<script>
export default {
    data(){
        return{
            t:'参与比赛赢好礼',
            list:[
                {
                    p1:'上万奖池',
                    p2:'等你赢',
                },
                {
                    p1:'查看高手',
                    p2:'参赛持仓',
                },
                {
                    p1:'跟踪高手',
                    p2:'实时调仓',
                },
                {
                    p1:'正收益',
                    p2:'有奖励',
                },
            ]
        }
    }
}

</script>
<style lang="scss" scoped>
    @import "~@/assets/sass/global.scss";
    .wrap{
        margin-top: rem(34px);
        background: #FFFFFF;
        border-radius: rem(20px);
        padding: rem(27px) rem(40px) rem(40px);

        >h1{
            font-size: rem(32px);
            text-align: center;
            font-weight: 600;
            color: #333333;
            line-height: rem(45px);
            margin-bottom: rem(33px);
        }

        .wrap2{
            display: flex;
            justify-content: space-between;
            img{
                width: rem(112px);
                margin-bottom: rem(10px);
            }
            p{
                text-align: center;
                height: rem(33px);
                font-size: rem(24px);
                font-weight: 400;
                color: #636363;
                line-height: rem(33px);
            }
        }
    }
</style>